null


// WEBPACK FOOTER //
// /Volumes/workplace/src/vendor/dom-utils/get-attributes.ts